import React from "react";
import ScaledLogo from "./ScaledLogo";
import styles from "./materials.module.scss";

const ArrowRight = () => (
  <svg width="533" height="48" viewBox="0 0 533 48" fill="none">
    <line x1="0" y1="24" x2="490" y2="24" stroke="currentColor" strokeWidth="12" strokeLinecap="round" />
    <polygon points="490,4 533,24 490,44" fill="currentColor" />
  </svg>
);

const ArrowLeft = () => (
  <svg width="533" height="48" viewBox="0 0 533 48" fill="none">
    <line x1="533" y1="24" x2="43" y2="24" stroke="currentColor" strokeWidth="12" strokeLinecap="round" />
    <polygon points="43,4 0,24 43,44" fill="currentColor" />
  </svg>
);

const ArrowDown = () => (
  <svg width="48" height="300" viewBox="0 0 48 300" fill="none">
    <line x1="24" y1="0" x2="24" y2="257" stroke="currentColor" strokeWidth="12" strokeLinecap="round" />
    <polygon points="4,257 24,300 44,257" fill="currentColor" />
  </svg>
);

const ArrowUp = () => (
  <svg width="48" height="300" viewBox="0 0 48 300" fill="none">
    <line x1="24" y1="300" x2="24" y2="43" stroke="currentColor" strokeWidth="12" strokeLinecap="round" />
    <polygon points="4,43 24,0 44,43" fill="currentColor" />
  </svg>
);

const ARROWS = { right: ArrowRight, left: ArrowLeft, down: ArrowDown, up: ArrowUp };

const SignEditable = ({ event, textColor, bgColor, editText, editArrow }) => {
  const Arrow = ARROWS[editArrow || "right"];

  return (
    <div className={styles.sign} style={{ "--mat-bg": bgColor, "--mat-text": textColor }}>
      <div className={styles.signLogoGroup}>
        <ScaledLogo color={event.color} width={499} height={575} />
        <span className={styles.signLogoText}>IxDA Stavanger</span>
      </div>
      <span className={styles.signEditableText}>
        {editText || "Your text here"}
      </span>
      <div className={styles.signArrow}>
        <Arrow />
      </div>
    </div>
  );
};

export default SignEditable;
